import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=5470cce5"
import script from "./ContextMenu.ts?vue&type=script&lang=js&external"
export * from "./ContextMenu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports